import { type FC, useState, useEffect } from 'react';
import { type DroppableProps, Droppable } from 'react-beautiful-dnd';

/**
 * A drop-in replacement for react-beautiful-dnd's Droppable component that handles React 18 StrictMode issues.
 * In StrictMode, components render twice, which can cause problems with draggable IDs.
 * This component delays rendering until the next animation frame to prevent double initialization.
 */
const DelayedDroppableWrapper: FC<DroppableProps> = ({ children, ...props }) => {
	const [enabled, setEnabled] = useState(false);

	useEffect(() => {
		const animation = requestAnimationFrame(() => setEnabled(true));
		return () => cancelAnimationFrame(animation);
	}, []);

	if (!enabled) {
		return null;
	}

	return <Droppable {...props}>{children}</Droppable>;
};

export default DelayedDroppableWrapper;
